import { render } from "./UserModal2.vue?vue&type=template&id=69284bb2"
import script from "./UserModal2.vue?vue&type=script&lang=ts"
export * from "./UserModal2.vue?vue&type=script&lang=ts"

import "./UserModal2.vue?vue&type=style&index=0&id=69284bb2&lang=css"
script.render = render

export default script